import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Box, Grid, makeStyles, TextField, Typography } from '@material-ui/core';

import DropdownInput from 'components/DropdownInput';
import TabPanel from 'components/TabPanel';
import MenuControls from 'components/Widget/components/menus/MainSettings/components/MenuControls';
import RichTextEditor from 'containers/admin/AdminRichTextEditor/components/RichTextEditor';

const dateFormat = 'DD-MM-YYYY';

const getDateRangeTypes = () =>
  [
    'Static date range',
    'Inception To Date',
    'Year To Date',
    'Last 12 Months',
    'Last 12 Month Less One Month',
    'Last 24 Month',
    'Last 36 Months'
  ].map((label, index) => ({ label, value: index }));

const useStyles = makeStyles({
  root: {
    flexGrow: 1
  },
  rootInput: {
    '& .MuiOutlinedInput-input': {
      padding: '9.5px 14px'
    }
  },
  modal_subtitle: {
    marginBottom: '30px'
  },
  textField: {
    paddingBottom: '25px',
    marginTop: '20px',
    marginRight: '15px'
  },
  header: {
    margin: '1rem 0',
    fontWeight: 'bold'
  },
  richTextContainer: {
    marginBottom: '1rem'
  }
});

const DashboardSettingsTab = ({
  value,
  onSubmit,
  handleClose,
  dashboardToUpdate,
  handlePropUpdate
}) => {
  const classes = useStyles();
  const { description, dateRangeTypeId, startDate, endDate, name } = dashboardToUpdate;
  const [startDateState, setStartDateState] = useState(moment(startDate).format(dateFormat));
  const [endDateState, setEndDateState] = useState(moment(endDate).format(dateFormat));

  const handleDateRangeChange = event => {
    handlePropUpdate(event);
  };

  const handleSubmit = () => {
    onSubmit(dashboardToUpdate);
  };

  const handleStartDateChange = event => {
    setStartDateState(event.target.value);
    handlePropUpdate(event);
  };

  const handleEndDateChange = event => {
    setEndDateState(event.target.value);
    handlePropUpdate(event);
  };

  const handleDescriptionChange = event => {
    const e = {
      target: {
        value: event,
        name: 'description'
      },
      persist: () => {}
    };
    handlePropUpdate(e);
  };

  return (
    <TabPanel value={value} index={0} style={{ maxWidth: '700px' }}>
      <Box
        component={Grid}
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
        spacing={2}
      >
        <Grid item xs={12} md={6}>
          <Typography className={classes.header}>Dashboard name</Typography>
          <TextField
            onChange={handlePropUpdate}
            value={name}
            name="name"
            label="Choose"
            variant="outlined"
            fullWidth
            classes={{
              root: classes.rootInput
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography className={classes.header}>Date range type</Typography>
          <DropdownInput
            selected={dateRangeTypeId.toString()}
            options={getDateRangeTypes()}
            onSelect={handleDateRangeChange}
            label="Choose"
            name="dateRangeTypeId"
          />
        </Grid>
        {dateRangeTypeId === 0 && (
          <Grid item xs={12}>
            <TextField
              id="date"
              onChange={handleStartDateChange}
              name="startDate"
              label="Start Date"
              type="date"
              display="inline"
              value={startDateState}
              className={classes.textField}
              InputLabelProps={{
                shrink: true
              }}
            />
            <TextField
              style={{ marginLeft: '55px' }}
              id="date"
              onChange={handleEndDateChange}
              name="endDate"
              label="End date"
              display="inline"
              type="date"
              value={endDateState}
              className={classes.textField}
              InputProps={{ inputProps: { min: startDateState } }}
              InputLabelProps={{
                shrink: true
              }}
            />
          </Grid>
        )}
        <Grid item xs={12} className={classes.richTextContainer}>
          <Typography className={classes.header}>Set dashboard description</Typography>
          <RichTextEditor
            onChange={handleDescriptionChange}
            defaultValue={description}
            marginTop={0}
            fullWidth
          />
        </Grid>
      </Box>
      <MenuControls handleClose={handleClose} useFormSubmit={false} onSubmit={handleSubmit} />
    </TabPanel>
  );
};

DashboardSettingsTab.propTypes = {
  value: PropTypes.number.isRequired,
  onSubmit: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  dashboardToUpdate: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    dateRangeTypeId: PropTypes.number
  }).isRequired,
  handlePropUpdate: PropTypes.func.isRequired
};

export default DashboardSettingsTab;
